import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const _s3Url = import.meta.env.VITE_NWDC_S3_URL;
const baseUrl = !_s3Url ? new URL('', location.origin).href : _s3Url;

export type Alert = {
  name: string;
  isDisplayed: string;
  type: 'emergency' | 'error' | 'warning' | 'info';
  heading: string;
  message: string;
};

type AlertsResponse = {
  alerts: Alert[];
};

export function parseAlerts(response: unknown): Alert[] {
  const res = response as AlertsResponse;
  if (!Array.isArray(res?.alerts)) return [];
  return res.alerts.filter(
    (a): a is Alert =>
      typeof a?.name === 'string' &&
      typeof a?.isDisplayed === 'string' &&
      typeof a?.message === 'string'
  );
}

export const alertsApi = createApi({
  reducerPath: 'alertsApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (build) => ({
    getAlerts: build.query<Alert[], void>({
      query: () => '/assets/json/alerts.json',
      transformResponse: parseAlerts,
    }),
  }),
});

export const { useGetAlertsQuery } = alertsApi;
export default alertsApi;
